import flow from 'lodash/flow';
import { withMedia } from 'react-media-query-hoc';
import withMediaQueryProvider from '@domain-group/fe-allhomes-library/lib/react/media-query-provider';
import { withAnalyticsProvider, withSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { withAllhomesContextProxy } from '@domain-group/fe-co-allhomes-global-context';
import eventMapper from './analytics-event-mapper';
var allhomesAgencyProfileWrapper = flow(withMedia, withSendEvent, withAnalyticsProvider(eventMapper), withAllhomesContextProxy, withMediaQueryProvider);
export default allhomesAgencyProfileWrapper;